import { Environments } from '@/config';
import { HELIX_CONE_PRODUCTION } from './helix-cone.production';
import { HELIX_CONE_STAGING } from './helix-cone.staging';

export const HELIX_CONE = import.meta.env.MODE === Environments.PROD ? HELIX_CONE_PRODUCTION : HELIX_CONE_STAGING;
